//旅程一起行
export const journeyTogetherRouter = [
  {
    path: '/service/journeyTogether/synchronousProducts',
    name: 'SynchronousProducts',
    component: () => import('@/views/service/serviceProvider/JourneyTogether/SynchronousProducts'),
    meta: {
      title: '同步产品',
      keepAlive: false
    }
  },
  {
    path: '/service/journeyTogether/directOrdersList',
    name: 'DirectOrdersList',
    component: () => import('@/views/service/serviceProvider/JourneyTogether/DirectOrdersList'),
    meta: {
      title: '订单直连',
      keepAlive: false
    }
  },
  {
    path: '/service/journeyTogether/associatedAccount',
    name: 'TogetherAccount',
    component: () => import('@/views/service/serviceProvider/JourneyTogether/TogetherAccount'),
    meta: {
      title: '关联账号',
      keepAlive: false
    }
  },
  {
    path: '/service/journeyTogether/synchronizationRules',
    name: 'SynchronizationRules',
    component: () => import('@/views/service/serviceProvider/JourneyTogether/SynchronizationRules'),
    meta: {
      title: '同步规则',
      keepAlive: false
    }
  },
  {
    path: '/service/journeyTogether/memberList',
    name: 'DistributionMember',
    component: () => import('@/views/service/serviceProvider/JourneyTogether/DistributionMember'),
    meta: {
      title: '关联分销员',
      keepAlive: false
    }
  }
]